import { render, staticRenderFns } from "./ruleChileren.vue?vue&type=template&id=f4b4ce8a&scoped=true&"
import script from "./ruleChileren.vue?vue&type=script&lang=js&"
export * from "./ruleChileren.vue?vue&type=script&lang=js&"
import style0 from "./ruleChileren.vue?vue&type=style&index=0&id=f4b4ce8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b4ce8a",
  null
  
)

export default component.exports